/**
 * mtop 接口请求。
 *
 * 注意：要求调用方环境存在 Promise 实现。
 *
 */

import mtop from '@ali/lib-mtop-open';

// mtop 的 appKey
const APP_KEYS = {
  daily: '4272',
  pre: '5512',
  prod: '5512'
};

const getMtopDomain = env => {
  return {
    // 基蜜网关配置
    daily: 'api-alimebot.alibaba.net',
    pre: 'pre-api-alimebot.alibaba.com',
    prod: 'api-alimebot.alibaba.com'
  }[env];
};

export default function requestMtop(apiName, data, opts = {}) {
  const config = {
    api: `mopen.xspace.chat.${apiName}`,
    type: 'GET',
    data
  };['type', 'timeout'].forEach(key => {
    if (opts[key] !== undefined) {
      config[key] = opts[key];
    }
  });

  return request(config, opts.env);
}

function request(config, env) {
  const mtopDomain = getMtopDomain(env);
  const appKey = APP_KEYS[env];

  if (mtop.config.mtopDomain !== mtopDomain) {
    mtop.config.mtopDomain = mtopDomain;
  }

  return mtop.request(Object.assign({
    v: '1.0', // 必须
    appKey // 必须
  }, config)).then(resp => {
    const { ret = [] } = resp;
    if (ret.length && ~ret[0].indexOf('SUCCESS')) {
      return resp.data;
    } else {
      throw new Error(ret[0] || 'Failed to send request');
    }
  }, error => {
    throw error;
  });
}


// WEBPACK FOOTER //
// ./node_modules/_@ali_im-sdk-third@0.1.8@@ali/im-sdk-third/lib/mtop.js